import React from 'react'
import { DropDown } from '../../../commons'
import { serviceTaxBasisDropDown, serviceTaxPeriodDropDown, serviceTaxRegisteredDropDown } from '../../../../constant/clientDirectoryDropDown';
import { DropDownType } from '../../../../commonTypes/clientDirectoryTypes';

type AppProps = {
    serviceTaxDetails: any;
    setTaxAndBillingDetails: (data: any) => void;
    isDisabled?:boolean
}
const ServiceTax = ({
    serviceTaxDetails,
    setTaxAndBillingDetails,
    isDisabled
}: AppProps) => {
    const option = [
        {
            value: "No",
            label: "No"
        },
        {
            value: "Yes",
            label: "Yes"
        }
    ]

    const handleServiceTaxChange = (data: DropDownType, name: string) => {
        if (name === "registered") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    serviceDetails: {
                        ...prev.serviceDetails,
                        serviceTaxRegistered: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
        else if (name === "period") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    serviceDetails: {
                        ...prev.serviceDetails,
                        serviceTaxPeriod: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
        else if (name === "basis") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    serviceDetails: {
                        ...prev.serviceDetails,
                        serviceTaxBasis: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
        else if (name === "tax") {
            setTaxAndBillingDetails((prev: any) => {
                return {
                    ...prev,
                    serviceDetails: {
                        ...prev.serviceDetails,
                        prepareServiceTax: {
                            value: data?.value,
                            label: data?.label
                        }
                    }
                }
            })
        }
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-3'>
                    <label htmlFor='Service Tax Registered'>Service Tax Registered</label>
                    <DropDown
                        options={serviceTaxRegisteredDropDown}
                        value={serviceTaxDetails?.serviceTaxRegistered}
                        handleChange={(e) => handleServiceTaxChange(e, "registered")}
                         disabled={isDisabled}
                    />
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Service Tax Period'>Service Tax Period</label>
                    <DropDown
                        options={serviceTaxPeriodDropDown}
                        value={serviceTaxDetails?.serviceTaxPeriod}
                        handleChange={(e) => handleServiceTaxChange(e, "period")}
                        disabled={isDisabled}
                    />
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Service Tax Basis'>Service Tax Basis</label>
                    <DropDown
                        options={serviceTaxBasisDropDown}
                        value={serviceTaxDetails?.serviceTaxBasis}
                        handleChange={(e) => handleServiceTaxChange(e, "basis")}
                        disabled={isDisabled}
                    />
                </div>
                <div className='col-md-3'>
                    <label htmlFor='Prepare Service Tax'>Prepare Service Tax</label>
                    <DropDown
                        options={option}
                        value={serviceTaxDetails?.prepareServiceTax}
                        handleChange={(e) => handleServiceTaxChange(e, "tax")}
                        disabled={isDisabled}
                    />
                </div>
            </div>
        </>
    )
}

export default ServiceTax